export default "__VITE_ASSET__BMggQFRS__"